<template>
  <el-dialog
    width="810px"
    class="top"
    :visible.sync="visible"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
  >
    <p class="description my-5">{{ $t('promotion.tradingRewards.selectAccLabel') }}</p>
    <el-form label-position="top" :model="accountForm" ref="accountForm" :rules="accountRules">
      <el-form-item prop="selectAccount">
        <el-select v-model="accountForm.selectAccount" :placeholder="$t('promotion.tradingRewards.selectAccDesc')">
          <el-option
            v-for="(item, index) in redeemableAccountOptions"
            :key="index"
            :value="item.mt4Account"
            :label="setLabel(item)"
            :data-testid="index"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="handleClose">{{ $t('promotion.tradingRewards.cancel') }}</el-button>
      <el-button type="primary" @click="submitAccount">{{ $t('promotion.tradingRewards.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import mixin from '@/mixins/language';
export default {
  name: 'SelectAccountDialog',
  props: {
    selectAccountDialogVisible: Boolean,
    redeemableAccountOptions: Array
  },
  //   mixins: [mixin],
  data() {
    return {
      visible: false,
      accountForm: {
        selectAccount: null
      },
      accountRules: {
        selectAccount: [
          {
            required: true,
            message: this.$t('promotion.tradingRewards.selectAccReq'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  watch: {
    selectAccountDialogVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.accountForm.selectAccount = null;
      this.$emit('update:selectAccountDialogVisible', bool);
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    submitAccount() {
      this.$refs['accountForm'].validate(valid => {
        if (valid) {
          this.$emit('submit', this.accountForm.selectAccount);
        } else return false;
      });
    },
    setLabel(item) {
      return `${item.mt4Account} - ${item.currency}`;
    }
  }
};
</script>
